import {WarningImageDefaultBox} from "./warning-image.default.box";

export const WarningImageBox = WarningImageDefaultBox;